import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.promise";
import "regenerator-runtime/runtime";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
DashboardManagerController.$inject = ["activityService", "storageService", "customerEngagementService", "authorizationService", "searchService", "environmentVariables", "dealerService", "assetTypes", "saleTypes"];

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/* injects from baggage-loader */
require('./dashboard-manager.component.html');

import angular from 'angular';
import moment from 'moment-timezone';
import { ApiActivityTypes } from '../../constants';
import { TimeZonesById, guessBrowserTimeZone } from '../../constants/time-zones';
import { widgetTypes } from '../../constants/widget-types';
import { EngagementEventGroups } from '../../constants/engagement-event-types.constant';
import './dashboard.scss';
angular.module('AaApp.Opp').component('dashboardManager', {
  templateUrl: '/app/components/dashboard/dashboard-manager.component.html',
  controller: DashboardManagerController,
  bindings: {
    selectedDealerId: "<",
    userId: "<"
  }
});

function DashboardManagerController(activityService, storageService, customerEngagementService, authorizationService, searchService, environmentVariables, dealerService, assetTypes, saleTypes) {
  "ngInject";

  var $ctrl = this;
  var MAX_ROWS = environmentVariables.managerDashboardCustomerEngagementMaxRows || 50;
  $ctrl.showHotLeadsOnly = false;
  $ctrl.showNotWorkedOnly = false;
  $ctrl.permissions = {};
  $ctrl.$onChanges = $onChanges;
  $ctrl.closeCallback = closeCallback;
  $ctrl.refreshWidgets = refreshWidgets;
  $ctrl.hotLeadsOnlyChanged = filtersChanged;
  $ctrl.NotWorkedChanged = filtersChanged;
  $ctrl.$onInit = init;
  $ctrl.showReviewPro = false;
  $ctrl.showGeoAlert = false;
  $ctrl.getWidgetColumnTypesList = getWidgetColumnTypesList;
  $ctrl.getWidgetLink = getWidgetLink;
  $ctrl.moveWidgetToTop = moveWidgetToTop;
  $ctrl.setFavoriteWidget = setFavoriteWidget;
  $ctrl.saveCollapseState = saveCollapseState; //const standardColumnTypes = ['customerEngagement', 'opportunity', 'alertBlocks'];

  var reviewProColumnTypes = ['customerEngagement', 'opportunity', 'reviewRating'];
  var emailTextOneToOneColumnTypes = ['customerEngagement', 'opportunity', 'groupEngagement', 'alertBlocks', 'emailtext'];
  var serviceColumnTypes = ['customerEngagement', 'opportunity', 'service', 'alertBlocks'];
  var webColumnTypes = ['customerEngagement', 'opportunity', 'web', 'alertBlocks'];
  var geoAlertColumnTypes = ['customerEngagement', 'opportunity', 'geoAlert'];
  var upComingApptColumnTypes = ['customerEngagement', 'opportunity', 'alertBlocks', 'upcoming'];
  var isEuroLite = authorizationService.isEuroLite(); //TODO:  refactor this to a centralized location.
  //Configuration

  $ctrl.leaseSaleTypes = [saleTypes.lease];
  $ctrl.retailSaleTypes = [saleTypes.retail, saleTypes.balloon];

  function setUpWidgets() {
    return _setUpWidgets.apply(this, arguments);
  }

  function _setUpWidgets() {
    _setUpWidgets = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              $ctrl.widgets = [{
                widgetDefaultOrder: 1,
                widgetType: widgetTypes.opportunitiesTable,
                widgetTitleKey: 'retailWidgetTitle',
                widgetExpandToolTipKey: 'expandretail',
                widgetLink: $ctrl.getWidgetLink('retail'),
                columnTypes: $ctrl.getWidgetColumnTypesList('retail'),
                widgetDataService: retailWidgetDataService,
                triggerRefresh: 0,
                isFavorite: false,
                isCollapsed: false
              }, {
                widgetDefaultOrder: 2,
                widgetType: widgetTypes.opportunitiesTable,
                widgetTitleKey: 'leaseWidgetTitle',
                widgetExpandToolTipKey: 'expandlease',
                widgetLink: $ctrl.getWidgetLink('lease'),
                columnTypes: $ctrl.getWidgetColumnTypesList('lease'),
                widgetDataService: leaseWidgetDataService,
                triggerRefresh: 0,
                isFavorite: false,
                isCollapsed: false
              }, {
                widgetDefaultOrder: 3,
                widgetType: widgetTypes.opportunitiesTable,
                widgetTitleKey: 'emailText',
                widgetExpandToolTipKey: 'email',
                icon: 'email-sms',
                highEngagementDescription: 'emailTextHighEngagementDescription',
                detailViewLinkDisabled: true,
                columnTypes: emailTextOneToOneColumnTypes,
                widgetDataService: function widgetDataService(force) {
                  return customerEngagementService.getCustomerEngagementByGroup($ctrl.selectedDealerId, {
                    engagementEventGroupIds: [EngagementEventGroups.email, EngagementEventGroups.text, EngagementEventGroups.autoAssistant],
                    take: MAX_ROWS,
                    hotLeadsOnly: $ctrl.showHotLeadsOnly,
                    notWorkedOnly: $ctrl.showNotWorkedOnly,
                    dealerId: $ctrl.selectedDealerId
                  }).then(function (mappedResponse) {
                    return mappedResponse.sort(function (a, b) {
                      return new Date(b.eventDate) - new Date(a.eventDate);
                    });
                  });
                },
                triggerRefresh: 0,
                isFavorite: false,
                isCollapsed: false
              }, {
                widgetDefaultOrder: 4,
                widgetType: widgetTypes.opportunitiesTable,
                widgetTitleKey: 'upcomingAppointments',
                widgetExpandToolTipKey: 'upcomingAppointments',
                icon: 'aa-icon-core-calendar-icon-000000',
                highEngagementDescription: 'todaysAppointments',
                detailViewLinkDisabled: true,
                columnTypes: upComingApptColumnTypes,
                widgetDataService: getUpcomingAppointments,
                triggerRefresh: 0,
                isFavorite: false,
                isCollapsed: false
              }, {
                widgetDefaultOrder: 5,
                widgetType: widgetTypes.agenda,
                widgetTitleKey: 'agendaWidgetTitle',
                widgetExpandToolTipKey: 'expandagenda',
                widgetLink: 'activitiesAgenda',
                widgetDataService: agendaWidgetDataService,
                triggerRefresh: 0,
                isFavorite: false,
                isCollapsed: false
              }, {
                widgetDefaultOrder: 6,
                widgetType: widgetTypes.opportunitiesTable,
                widgetTitleKey: 'recentlyAssignedWidgetTitle',
                widgetExpandToolTipKey: 'expandrecentlyAssigned',
                widgetDataService: recentlyAssignedWidgetDataService,
                detailViewLinkDisabled: true,
                columnTypes: ['opportunity', 'alertBlocks', 'assignedDate'],
                triggerRefresh: 0,
                isFavorite: false,
                isCollapsed: false
              }, {
                widgetDefaultOrder: 7,
                widgetType: widgetTypes.opportunitiesTable,
                widgetTitleKey: 'service',
                widgetExpandToolTipKey: 'service',
                icon: 'aa-icon-service-drive',
                highEngagementDescription: 'serviceHighEngagementDescription',
                detailViewLinkDisabled: true,
                columnTypes: serviceColumnTypes,
                widgetDataService: function widgetDataService(force) {
                  return customerEngagementService.getCustomerEngagementByGroup($ctrl.selectedDealerId, {
                    engagementEventGroupIds: [EngagementEventGroups.service],
                    take: MAX_ROWS,
                    hotLeadsOnly: $ctrl.showHotLeadsOnly,
                    notWorkedOnly: $ctrl.showNotWorkedOnly,
                    dealerId: $ctrl.selectedDealerId
                  });
                },
                triggerRefresh: 0,
                isFavorite: false,
                isCollapsed: false
              }, {
                widgetDefaultOrder: 8,
                widgetType: widgetTypes.opportunitiesTable,
                widgetTitleKey: 'oneToOne',
                widgetExpandToolTipKey: 'oneToOne',
                icon: 'marketing-mailer-icon-white',
                highEngagementDescription: 'o2oHighEngagementDescription',
                detailViewLinkDisabled: true,
                columnTypes: emailTextOneToOneColumnTypes,
                widgetDataService: function widgetDataService(force) {
                  return customerEngagementService.getCustomerEngagementByGroup($ctrl.selectedDealerId, {
                    engagementEventGroupIds: [EngagementEventGroups.one2one, EngagementEventGroups.intelligentMarketing],
                    take: MAX_ROWS,
                    hotLeadsOnly: $ctrl.showHotLeadsOnly,
                    notWorkedOnly: $ctrl.showNotWorkedOnly,
                    dealerId: $ctrl.selectedDealerId
                  });
                },
                triggerRefresh: 0,
                isFavorite: false,
                isCollapsed: false
              }, {
                widgetDefaultOrder: 9,
                widgetType: widgetTypes.opportunitiesTable,
                widgetTitleKey: 'web',
                widgetExpandToolTipKey: 'web',
                icon: 'web',
                highEngagementDescription: 'webHighEngagementDescription',
                detailViewLinkDisabled: true,
                columnTypes: webColumnTypes,
                widgetDataService: function widgetDataService(force) {
                  return customerEngagementService.getCustomerEngagementByGroup($ctrl.selectedDealerId, {
                    engagementEventGroupIds: [EngagementEventGroups.web],
                    take: MAX_ROWS,
                    hotLeadsOnly: $ctrl.showHotLeadsOnly,
                    notWorkedOnly: $ctrl.showNotWorkedOnly,
                    dealerId: $ctrl.selectedDealerId
                  });
                },
                triggerRefresh: 0,
                isFavorite: false,
                isCollapsed: false
              }];
              _context.next = 3;
              return dealerService.getIsAssetEnabledForDealer(assetTypes.reviewBuilderPro, $ctrl.selectedDealerId);

            case 3:
              $ctrl.showReviewPro = _context.sent;

              if ($ctrl.showReviewPro === true) {
                $ctrl.widgets.push({
                  widgetDefaultOrder: 10,
                  widgetType: widgetTypes.opportunitiesTable,
                  widgetTitleKey: 'reviews',
                  widgetExpandToolTipKey: '',
                  icon: 'reviews',
                  highEngagementDescription: '',
                  detailViewLinkDisabled: true,
                  columnTypes: reviewProColumnTypes,
                  widgetDataService: function widgetDataService(force) {
                    return customerEngagementService.getCustomerEngagementByGroup($ctrl.selectedDealerId, {
                      engagementEventGroupIds: [EngagementEventGroups.reviews],
                      take: MAX_ROWS,
                      hotLeadsOnly: 0,
                      notWorkedOnly: $ctrl.showNotWorkedOnly,
                      dealerId: $ctrl.selectedDealerId
                    });
                  },
                  triggerRefresh: 0,
                  isFavorite: false,
                  isCollapsed: false
                });
              }

              _context.next = 7;
              return dealerService.getIsAssetEnabledForDealer(assetTypes.geoAlert, $ctrl.selectedDealerId);

            case 7:
              $ctrl.showGeoAlert = _context.sent;

              if ($ctrl.showGeoAlert === true) {
                $ctrl.widgets.push({
                  widgetDefaultOrder: 11,
                  widgetType: widgetTypes.opportunitiesTable,
                  widgetTitleKey: 'geoAlert',
                  widgetExpandToolTipKey: 'geoAlert',
                  icon: 'geo-alert-icon-white',
                  highEngagementDescription: 'geoAlertTypeActive',
                  detailViewLinkDisabled: true,
                  columnTypes: geoAlertColumnTypes,
                  widgetDataService: function widgetDataService(force) {
                    return customerEngagementService.getCustomerEngagementByGroup($ctrl.selectedDealerId, {
                      engagementEventGroupIds: [EngagementEventGroups.geoAlert],
                      take: MAX_ROWS,
                      hotLeadsOnly: $ctrl.showHotLeadsOnly,
                      notWorkedOnly: $ctrl.showNotWorkedOnly,
                      dealerId: $ctrl.selectedDealerId
                    });
                  },
                  triggerRefresh: 0,
                  isFavorite: false,
                  isCollapsed: false
                });
              } // Get favorites from localstorage and re-order:


              showFavorites();
              showCollapseState();

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
    return _setUpWidgets.apply(this, arguments);
  }

  function showCollapseState() {
    var widgetStr = storageService.getItem('localPriorityCollapseState_' + $ctrl.userId);

    if (widgetStr != null) {
      var widgetList = widgetStr.split(",");
      widgetList.forEach(function (widget) {
        var widgetSetting = widget.split(":");
        var index = widgetSetting[0];
        var collapseState = widgetSetting[1];

        var widgetIndex = _.findIndex($ctrl.widgets, {
          widgetDefaultOrder: parseInt(index)
        });

        if (widgetIndex >= 0) {
          $ctrl.widgets[widgetIndex].isCollapsed = collapseState == "1" ? true : false;
        }
      });
    }
  }

  function showFavorites() {
    var favoritesStr = storageService.getItem('localPriorityDashFavs_' + $ctrl.userId);

    if (favoritesStr != null) {
      $ctrl.widgets.sort(byDefaultOrder);
      var favorites = favoritesStr.split(",");

      for (var i = favorites.length - 1; i >= 0; i--) {
        var index = _.findIndex($ctrl.widgets, {
          widgetDefaultOrder: parseInt(favorites[i])
        });

        if (index > 0) {
          $ctrl.widgets[index].isFavorite = true;
          moveWidgetToTop(index);
        }
      }
    }
  }

  function byDefaultOrder(object1, object2) {
    if (object1.widgetDefaultOrder < object2.widgetDefaultOrder) return -1;
    if (object1.widgetDefaultOrder > object2.widgetDefaultOrder) return 1;
    return 0;
  }

  function setFavoriteWidget(index, isOn) {
    // get index from order field:
    var widgetIndex = _.findIndex($ctrl.widgets, {
      widgetDefaultOrder: index
    });

    if (!isOn) {
      $ctrl.widgets[widgetIndex].isFavorite = false;
    } else {
      $ctrl.widgets[widgetIndex].isFavorite = true;
      moveWidgetToTop(widgetIndex);
    }

    saveFavorites();
    showFavorites();
  }

  function saveCollapseState(index, isCollapsed) {
    var collapseState = "";

    var widgetIndex = _.findIndex($ctrl.widgets, {
      widgetDefaultOrder: index
    });

    $ctrl.widgets[widgetIndex].isCollapsed = isCollapsed;
    $ctrl.widgets.forEach(function (widget) {
      collapseState = collapseState + "," + widget.widgetDefaultOrder + ":" + (widget.isCollapsed ? "1" : "0");
    });
    storageService.setItem('localPriorityCollapseState_' + $ctrl.userId, collapseState.substring(1));
  }

  function saveFavorites() {
    var favorites = "";
    $ctrl.widgets.forEach(function (widget) {
      if (widget.isFavorite) {
        favorites = favorites + "," + widget.widgetDefaultOrder;
      }
    });
    storageService.setItem('localPriorityDashFavs_' + $ctrl.userId, favorites.substring(1));
  }

  function moveWidgetToTop(from) {
    $ctrl.widgets.splice(0, 0, $ctrl.widgets.splice(from, 1)[0]);
  }

  function init() {
    authorizationService.getDealSheetPermissions().then(function (data) {
      $ctrl.permissions = data;
    });
  }

  function $onChanges(changes) {
    if (changes.selectedDealerId) {
      setUpWidgets().then(function (result) {
        if (!changes.selectedDealerId.isFirstChange()) {
          refreshWidgets();
        }
      });
    }
  }

  function closeCallback(type) {
    //refresh
    switch (type) {
      case widgetTypes.lease:
      case widgetTypes.retail:
      case widgetTypes.newOpportunityChanges:
        $ctrl.refreshWidgets();
        break;

      case widgetTypes.agenda:
      case widgetTypes.recentlyAssigned:
      default:
        break;
    }
  }

  function refreshWidgets() {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = $ctrl.widgets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var widget = _step.value;
        widget.triggerRefresh++;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  function filtersChanged() {
    refreshWidgets();
  }

  function getWidgetLink(type) {
    if (isEuroLite) return 'euroliteopportunities';

    switch (type) {
      case 'lease':
        return 'opportunitiesLease';

      case 'retail':
        return 'opportunitiesRetail';
    }
  }

  function getWidgetColumnTypesList(type) {
    switch (type) {
      case 'lease':
        if (isEuroLite) return ['opportunity', 'alertBlocks'];else return ['opportunity', 'alertBlocks', 'apptOrRoDate', 'lease'];

      case 'retail':
        if (isEuroLite) return ['opportunity', 'alertBlocks'];else return ['opportunity', 'alertBlocks', 'apptOrRoDate', 'retail'];

      default:
        return ['opportunity', 'alertBlocks', 'apptOrRoDate'];
    }
  }

  function leaseWidgetDataService(flushCache) {
    return searchService.getOpenOpportunities($ctrl.selectedDealerId, $ctrl.leaseSaleTypes, flushCache);
  }

  function retailWidgetDataService(flushCache) {
    return searchService.getOpenOpportunities($ctrl.selectedDealerId, $ctrl.retailSaleTypes, flushCache);
  }

  function recentlyAssignedWidgetDataService(flushCache) {
    return searchService.getRecentlyAssignedOpportunities($ctrl.selectedDealerId, flushCache);
  }

  function agendaWidgetDataService(flushCache) {
    return activityService.getAgendaItems($ctrl.selectedDealerId, null, flushCache);
  }

  function getUpcomingAppointments() {
    // This ought to be the _dealer's_ time zone, not the user's, but we
    // don't have that info. We fall back to the browser's time zone if the
    // profile's time zone is not set.
    var timeZone = TimeZonesById[storageService.getItem('timezoneId')] || guessBrowserTimeZone();
    var now = moment();
    var startOfToday = now.clone().tz(timeZone.tzdbName).startOf('day');
    var dateTo = startOfToday.clone().add(30, 'days');
    return activityService.getAgendaItemsWithEntityData({
      dateFrom: startOfToday.toDate(),
      dateTo: dateTo.toDate(),
      activityTypes: [ApiActivityTypes.appointment],
      take: MAX_ROWS
    }).then(function (appts) {
      return appts.map(function (appt) {
        return _objectSpread({}, appt, {
          // Faking the highEngagement flag is easier than editing
          // dashboardOpportunitiesTable so it understands "today"
          highEngagement: moment(appt.dueDate).isSame(now, 'day')
        });
      });
    }).then(function (appts) {
      if ($ctrl.showHotLeadsOnly) {
        return appts.filter(function (appt) {
          return appt.highEngagement;
        });
      } else {
        return appts;
      }
    });
  }
}